import Mock from 'mockjs'


function fakeSuccess(data) {
    const json = { code: 200, success: true, msg: '操作成功' }
    json.data = data
    return json
}
export default ({ mock }) => {
    if (!mock) return;

    // 统计分析-头部信息
    let topJson = {
        callSum:119,//总呼叫数
        addCallIndex:2,//新增呼叫数
        serviceIndex:12,//服务机构数
        fulfillIndex:8,//已完成数
        allTeenagerSum:86015,//全区青少年数量
        underwayIndex:110,//进行中数
        TerminationServiceIndex:5,//服务终止数
        monthIncreaseIndex:0,//当月订单度增长数量
        quarterIncreaseIndex:0,//当月订单增长率(上月比)
        yearIncreaseIndex:0,//年增长率
    }
    Mock.mock(
        /\/api\/blade-stat\/statistical\/statisticalTopData/,
        'get',
        fakeSuccess(topJson)
    )
}
